import { useMemo } from 'react';
import { AvailabilityBlock } from '@mews-commander/data-access';
import { createSafeContext } from '@mews/framework';
import { useTableState } from '@optimus-web/core';

export const useReportTableStateValue = () => {
    const [tableState, setTableState] = useTableState<AvailabilityBlock>();

    return useMemo(
        () => ({
            tableState,
            setTableState,
        }),
        [tableState, setTableState]
    );
};

export const { AvailabilityBlockReportContextProvider, useAvailabilityBlockReportContext } = createSafeContext<
    'AvailabilityBlockReportContext',
    ReturnType<typeof useReportTableStateValue>
>('AvailabilityBlockReportContext');
